import { useEffect, useMemo, useState } from 'react';
import { PluginConfig } from '../models/plugin-config';
import { fetchCssVariables } from '../services/css-service';
import { Club } from '../models/club';

type CssVariables = Record<string, string>;

export function useCssVariables(
  club: Club | null,
  config: PluginConfig | null | undefined
) {
  const [cssVariables, setCssVariables] = useState<CssVariables | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const cssVariablesString = useMemo(() => {
    if (cssVariables) {
      return Object.entries(cssVariables)
        .map(([key, value]) => `\n--${key}: ${value};`)
        .join('');
    }
    return null;
  }, [cssVariables]);

  useEffect(() => {
    if (!config || !club || isLoading) return;

    setIsLoading(true);
    fetchCssVariables(config.chainId, config.language)
      .then((data: CssVariables) => {
        if (data) {
          setCssVariables(data);
        }
      })
      .catch((e) => setError(e.message))
      .finally(() => setIsLoading(false));
  }, [config, club]);

  useEffect(() => {
    if (cssVariablesString) {
      const styleTag = document.createElement("style");
      styleTag.textContent = `html body #simplex-club-plugin {${cssVariablesString}}`;
      document.head.appendChild(styleTag);
      return () => {
        styleTag.remove();
      };
    }
  }, [cssVariablesString]);

  return {
    cssVariables,
    isLoading,
    error,
    cssVariablesString,
  };
}
